import React from "react";
import AnnoucementImage01 from "../../../../assets/image/image-annoucement-01.webp";
import Image from "../../../elements/Image";
import { useParams } from "react-router-dom";
import useFetch from "../../../../hooks/useFetch";
import { blogDetails } from "../../../../services/BlogService";
import dayjs from "dayjs";
import Quiltext from "../../../elements/Quiltext";
import NoImage from "../../../../assets/images/no-image-available.png";
import { classNames } from "../../../../helpers/classNames";

const SectionAnnoucementDetails = () => {
  const { slug } = useParams();

  // const announcementData = {
  //   _id: 1,
  //   title: "Scholarship Application Webinar",
  //   description:
  //     "Join us for an informative session on how to apply for the V’Peters Family Scholarship. We’ll cover eligibility, application tips, and FAQs.",
  //   image: AnnoucementImage01,
  //   date: "March 15, 2025",
  //   time: {
  //     start: "2:00 PM",
  //     end: "4:00 PM",
  //   },
  //   contact: {
  //     email: "contact@vpeters.org",
  //   },
  //   action: {
  //     label: "Registration Link",
  //     link: "/",
  //   },
  // };

  const {
    data: announcementData,
    error,
    isLoading,
    updateData,
    isFetching,
    refetch,
  } = useFetch({
    dependencies: ["font-event-detaills", slug],
    fetchFunction: async () => {
      const res = await blogDetails({
        slug,
        upcomingEvent: true,
      });
      if (res?.status === 200) {
        return {
          ...res?.data,
          image: res?.data?.image?.url,
          date: `${dayjs(res?.data?.publishDate)?.format(
            "ddd, MMM DD, YYYY"
          )} - ${dayjs(res?.data?.publishEndDate)?.format(
            "ddd, MMM DD, YYYY"
          )}`,
          time: {
            start: res?.data?.startTime,
            end: res?.data?.endTime,
            timezone: res?.data?.timezone,
          },
          contact: {
            email: res?.data?.email,
          },
          action: {
            label: res?.data?.location?.label,
            link: res?.data?.location?.url,
          },
          postedBy: "Admin",
        };
      } else {
        return {};
      }
    },
    enabled: !!slug,
  });
  return (
    <>
      <section className="relative flex w-full py-16 sm:py-24 bg-white !pt-40">
        <div className="w-full sm:max-w-xl md:max-w-2xl lg:max-w-4xl xls:max-w-6xl xl:max-w-7xl 2xl:max-w-8xl 3xl:max-w-9xl mx-auto px-4">
          <div className="relative lg:flex py-8 px-8 bg-chestnut-rose gap-8">
            <div className="flex-shrink-0 lg:w-1/2 flex mb-8 lg:mb-0">
              <div className="w-full overflow-hidden flex !bg-shades-03">
                <Image
                  src={announcementData?.image || NoImage}
                  alt={""}
                  effect="blur"
                  classes={classNames(
                    announcementData?.image
                      ? "object-cover"
                      : "object-contain scale-[0.6]"
                  )}
                />
              </div>
            </div>
            <div className="flex-shrink flex-grow space-y-8 text-white lg:w-1/2">
              <div className="space-y-4">
                {announcementData?.title && (
                  <h2 className="text-3xl font-bold">
                    {announcementData?.title}
                  </h2>
                )}
                {announcementData?.date && (
                  <div className="flex-shrink-0 flex flex-col items-start text-white gap-4">
                    {announcementData?.date && (
                      <div className="font-CanelaDeck text-lg gap-x-2 flex items-center whitespace-nowrap">
                        <i className="text-2xl fa-regular fa-fw fa-calendars"></i>{" "}
                        {announcementData?.date}
                      </div>
                    )}
                    {announcementData?.time && (
                      <div className="font-CanelaDeck text-lg gap-x-2 flex items-center whitespace-nowrap">
                        <i className="text-2xl fa-regular fa-fw fa-clock"></i>{" "}
                        {announcementData?.time?.start} -{" "}
                        {announcementData?.time?.end}{" "}
                        {announcementData?.time?.timezone}
                      </div>
                    )}
                  </div>
                )}
              </div>
              {announcementData?.description && (
                <div className="space-y-2">
                  <div className="text-2xl font-medium">Description:</div>
                  <Quiltext description={announcementData?.description} />
                </div>
              )}
              {announcementData?.action && (
                <div className="flex items-center gap-2">
                  <i className="text-2xl fa-regular fa-fw fa-clipboard-list-check"></i>
                  <a
                    href={announcementData?.action?.link}
                    target="_blank"
                    rel="noreferrer"
                    className="font-CanelaDeck text-xl gap-x-2 flex items-center text-white"
                  >
                    {announcementData?.action?.label}
                  </a>
                </div>
              )}
              {announcementData?.contact?.email && (
                <div className="flex items-center gap-2">
                  <i className="text-2xl fa-regular fa-fw fa-envelope"></i>
                  <div className="text-xl">Email:</div>
                  <a
                    href={"mailto:" + announcementData?.contact?.email}
                    className="font-CanelaDeck text-xl gap-x-2 flex items-center underline text-white"
                  >
                    {announcementData?.contact?.email}
                  </a>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default SectionAnnoucementDetails;
